import { reduxForm, formValueSelector } from "redux-form";
import { Pages, Validate } from "./dynamic-page";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

const mapStateToProps = (state, { form, questionTag, ...props }) => {
  const selector = formValueSelector(form); // <-- same as form name
  const primaryQuestion = selector(state, `question_${questionTag}`);
  return {
    primaryQuestion,
  };
};

export default injectIntl(
  reduxForm({
    validate: Validate,
  })(connect(mapStateToProps)(Pages))
);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/PageWithFormValues.js